module.exports = __webpack_public_path__ + "static/img/1740_phase_function_Paper_Points.cfb0c25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1740_phase_function_Paper_Points.png
// module id = c8NY
// module chunks = 0